import './assets/styles.css';const o = "_colorPicker_1uv6o_1", c = "_button_1uv6o_10", r = "_colorArea_1uv6o_14", l = "_colorFields_1uv6o_25", _ = "_colorField_1uv6o_25", t = "_colorFieldLabel_1uv6o_35", e = "_colorFieldInput_1uv6o_36", s = "_hex_1uv6o_50", u = "_hue_1uv6o_54", a = "_saturation_1uv6o_58", n = "_brightness_1uv6o_59", i = "_alpha_1uv6o_60", h = "_colorSlider_1uv6o_67", d = "_colorSliderTrack_1uv6o_70", v = "_colorThumb_1uv6o_82", S = "_colorSwatchPicker_1uv6o_101", b = "_colorSwatchItem_1uv6o_109", F = "_colorSwatch_1uv6o_101", k = {
  colorPicker: o,
  button: c,
  colorArea: r,
  colorFields: l,
  colorField: _,
  colorFieldLabel: t,
  colorFieldInput: e,
  hex: s,
  hue: u,
  saturation: a,
  brightness: n,
  alpha: i,
  colorSlider: h,
  colorSliderTrack: d,
  colorThumb: v,
  colorSwatchPicker: S,
  colorSwatchItem: b,
  colorSwatch: F
};
export {
  k as c
};
